import React from "react";
import { number, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { getStoryDate } from "../../utils/utils";

import "./publishedAt.m.css";

const PublishedAt = ({ date, className = "published-at", lang }) => {
  if (!date) {
    return null;
  }

  return (
    <time styleName="published-at" className={className}>
      {getStoryDate(date, lang)}
    </time>
  );
};

PublishedAt.propTypes = {
  date: number,
  className: string,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(PublishedAt);
